var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7004 9.00115C29.7004 9.00115 29.4073 6.93381 28.5078 6.02342C27.367 4.82854 26.0883 4.82262 25.5019 4.75268C21.3038 4.44922 15.0065 4.44922 15.0065 4.44922H14.9935C14.9935 4.44922 8.6963 4.44922 4.49809 4.75268C3.91165 4.82262 2.63339 4.82854 1.49219 6.02342C0.592719 6.93381 0.300019 9.00115 0.300019 9.00115C0.300019 9.00115 0 11.4289 0 13.8566V16.1325C0 18.5602 0.300025 20.9879 0.300025 20.9879C0.300025 20.9879 0.592725 23.0553 1.49219 23.9657C2.6334 25.1605 4.13244 25.1227 4.80011 25.248C7.20017 25.4781 15 25.5493 15 25.5493C15 25.5493 21.3038 25.5399 25.5019 25.2364C26.0883 25.1664 27.367 25.1605 28.5078 23.9657C29.4073 23.0553 29.7004 20.9879 29.7004 20.9879C29.7004 20.9879 30 18.5602 30 16.1325V13.8566C30 11.4289 29.7004 9.00115 29.7004 9.00115Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9027 18.8901L11.9014 10.4609L20.0075 14.6902L11.9027 18.8901Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0185ef99.svg";
export { ForwardRef as ReactComponent };